import { Phase } from '@/features/orders/constants/app'
import { TabBadge, TabBadgeSlotProps } from '@/features/ui/navigation'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { FC, memo } from 'react'

const OrdersTabBadge: FC<TabBadgeSlotProps> = ({ active }) => {
    const countReady = useAppSelector(ordersSelectors.isOrdersLoaded)
    const countNew = useAppSelector(ordersSelectors.countByPhase(Phase.New))

    if (!countReady) return null

    return <TabBadge inverted={!active}>{countNew.toString()}</TabBadge>
}

export default memo(OrdersTabBadge)
